import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { loadGuaranteeCassettes } from './api';
import { cassetteFallbackGuarantee } from './cassetteFallbacks';


function formatDate(value) {
    if (!value) {
        return '—';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleDateString('ru-RU');
}


export default function CassetteGuaranteeDetailPage() {
    const { serialNumber } = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState({
        item: null,
        loading: true,
        warning: '',
    });

    useEffect(() => {
        let cancelled = false;

        async function bootstrap() {
            try {
                const payload = await loadGuaranteeCassettes({
                    search: serialNumber,
                    page: 1,
                    page_size: 50,
                });
                const item = (payload.results?.items || []).find((module) => module.serial_number === serialNumber) || null;
                if (!cancelled) {
                    setState({
                        item,
                        loading: false,
                        warning: item ? '' : 'Кассета не найдена в гарантийной выборке.',
                    });
                }
            } catch (_error) {
                const fallback = (cassetteFallbackGuarantee.results?.items || []).find((module) => module.serial_number === serialNumber) || null;
                if (!cancelled) {
                    setState({
                        item: fallback,
                        loading: false,
                        warning: fallback ? 'Показан локальный пример.' : 'Кассета не найдена в гарантийной выборке.',
                    });
                }
            }
        }

        bootstrap();

        return () => {
            cancelled = true;
        };
    }, [serialNumber]);

    return (
        <div className="shell-page">
            <section className="shell-section shell-section--pageTop">
                <div className="shell-pageHeaderCompact">
                    <div className="shell-pageBandIntro">
                        <h3>Гарантийная кассета</h3>
                    </div>
                    <div className="shell-actionCluster">
                        <button
                            type="button"
                            className="shell-actionButton shell-actionButton--secondary"
                            onClick={() => navigate('/app/cassettes')}
                        >
                            Назад к кассетам
                        </button>
                    </div>
                </div>
            </section>

            {state.warning ? <div className="shell-banner">{state.warning}</div> : null}

            {state.loading ? (
                <section className="shell-section">
                    <div className="shell-emptyState shell-emptyState--compact">Загружаем кассету...</div>
                </section>
            ) : state.item ? (
                <section className="shell-section">
                    <div className="shell-sectionHeader">
                        <div>
                            <h3>{state.item.serial_number}</h3>
                        </div>
                        <span>{state.item.location?.city || '—'}</span>
                    </div>

                    <div className="shell-requestDetail">
                        <div className="shell-requestDetailGrid">
                            <div className="shell-requestDetailItem">
                                <span>Серийный номер</span>
                                <strong>{state.item.serial_number}</strong>
                            </div>
                            <div className="shell-requestDetailItem">
                                <span>Партия</span>
                                <strong>{state.item.party_number || '—'}</strong>
                            </div>
                            <div className="shell-requestDetailItem">
                                <span>Система</span>
                                <strong>{state.item.system || '—'}</strong>
                            </div>
                            <div className="shell-requestDetailItem">
                                <span>Статус ремонта</span>
                                <strong>{state.item.repair_status || '—'}</strong>
                            </div>
                            <div className="shell-requestDetailItem">
                                <span>Статус перемещения</span>
                                <strong>{state.item.movement_status || '—'}</strong>
                            </div>
                            <div className="shell-requestDetailItem">
                                <span>Дата ремонта</span>
                                <strong>{formatDate(state.item.date_repair)}</strong>
                            </div>
                            <div className="shell-requestDetailItem">
                                <span>Инженер</span>
                                <strong>{state.item.engineer || '—'}</strong>
                            </div>
                            <div className="shell-requestDetailItem">
                                <span>Локация</span>
                                <strong>{state.item.location?.city || '—'}</strong>
                            </div>
                            <div className="shell-requestDetailItem">
                                <span>Комментарий</span>
                                <strong>{state.item.comment || '—'}</strong>
                            </div>
                        </div>
                    </div>
                </section>
            ) : null}
        </div>
    );
}
